import { Header, Navbar, Inventory } from "../components"
import CallToAction from '../components/cta/CallToAction';
import Footer from '../components/footer/Footer';

export default function Home() {
    return (
        <div>
            <Navbar />
            <Header />
            <Inventory />
            <CallToAction />
            <Footer />
        </div>
    )
}